'use strict';

import React, {Component, PropTypes} from 'react';
import Select from 'react-select';

import '../public/css/form.css';
import 'purecss/build/pure.css';
import 'react-ghfork/gh-fork-ribbon.ie.css';
import 'react-ghfork/gh-fork-ribbon.css';
import 'react-pagify/style.css';
import DataTable from './table.js';
import {FormatMessage} from 'react-globalize';
import Globalize from 'globalize';


class BfgBillersList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      countrySelected: 'MEX',
      data: [],
      payerData: []
    };

    this.updateCountry = this.updateCountry.bind(this);
    this.updateBiller = this.updateBiller.bind(this);
  }


  render() {
    var countries = this.state.data || [];

    return (<form className="sendMoney-form form-inline">
      <header><FormatMessage locale={this.props.locale} path="sendMoneyPage/paymentSearch" /></header>
      <div className="margin-bottom-10"></div>
      <div className="row">
        <div className="col col-md-6 col-md-offset-1 col-xs-8 col-xs-offset-1 col-sm-8 col-sm-offset-1">
            <div >
              <Select ref="country" id="country" options={countries} simpleValue name="country"  value={this.state.countrySelected} onChange={this.updateCountry} placeholder={Globalize(this.props.locale).messageFormatter("sendMoneyPage/selectCountry")()} clearable searchable  />
            </div>
        </div>

      </div>
    <div className="margin-bottom-10"></div>
    <div className="margin-bottom-10"></div>
      <div className="row">
          <div className="col col-xs-10 col-xs-offset-1 col-md-offset-1">
          <DataTable locale={this.props.locale}   id="payersList" data={this.state.payerData} title="sendMoneyPage/paymentList" />
          </div>
      </div>

        <div>&nbsp;</div>
        <div>&nbsp;</div>
        <div>&nbsp;</div>
        </form>
      );
  }

  loadCountriesFromServer () {
    $.ajax({
        url:'/api/countries',
        type: 'POST',
        dataType: 'json',
        cache: false,
        success: function(data) {
          this.setState({data: data});
        }.bind(this),
        error: function(xhr, status, err) {
        console.error(this.props.url, status, err.toString());
      }.bind(this)
    });
  }

  loadBillersFromServer (idCountry) {
      if(idCountry == null)
        this.setState({payerData: []});
      else
          $.ajax({
            url:'/api/payersCountry',
            type: 'POST',
            dataType: 'json',
            data:{country_iso:idCountry},
            cache: false,
            success: function(data) {
              this.setState({payerData: data});
            }.bind(this),
            error: function(xhr, status, err) {
              console.error(this.props.url, status, err.toString());
            }.bind(this)
          });
    }

  updateCountry (idCountry) {

    this.loadBillersFromServer(idCountry);

    this.setState({
      countrySelected: idCountry,
    });


  }

  updateBiller (newValue) {

    this.setState({
      billerSelected: newValue
    });
  }

  focusStateSelect () {
    this.refs.billerSelected.focus();
  }

  componentDidMount () {
    this.loadCountriesFromServer();
    this.loadBillersFromServer(this.state.countrySelected);
    var text = Globalize(this.props.locale).messageFormatter("buttons/bttn_search")();
    $('.controls input').attr("placeholder", text);
  }

  componentDidUpdate(prevProps, prevState){
    var text = Globalize(this.props.locale).messageFormatter("buttons/bttn_search")() + "...";
    $('.controls input').attr("placeholder", text);
  }


};




/*BfgBillersList.propTypes = {
  countrySelected: PropTypes.string,
  billerSelected: PropTypes.string,
  payerData: PropTypes.object,
  errors: PropTypes.object,
  validate:PropTypes.func,
  isValid: PropTypes.func,
  handleValidation:PropTypes.func,
  getValidationMessages: PropTypes.func,
  clearValidations: PropTypes.func
};*/



module.exports = (BfgBillersList);







// WEBPACK FOOTER //
// ./js/billersList.js